import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { takeUntil } from 'rxjs/operators';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { sweetAlert } from 'src/app/utils/swal';

@Component({
  selector: 'app-bulk-call-review-modal',
  templateUrl: './bulk-call-review-modal.component.html',
  styleUrls: ['./bulk-call-review-modal.component.css']
})
export class BulkCallReviewModalComponent implements OnInit, OnDestroy {

  @Input() groups: any[] = [];
  preSpaceTypes: any
  preCooperates: any
  @Input() lookupData: any
  @Output() onClose = new EventEmitter<void>();
  @Output() onSave = new EventEmitter<any[]>();
  timeFormat: string = 'HHmm';
  timeZone: any;
  user:any

  constructor(private sharedDataService: SharedDataService,) { }

  ngOnInit() {
    const { spaceTypes, cooperates } = this.lookupData;
    this.preSpaceTypes = spaceTypes;
    this.preCooperates = cooperates;
    this.getUser()
  }

  getUser() {
    this.sharedDataService
      .getUser().pipe(takeUntil(componentDestroyed(this))).subscribe((data) => {
        if (data) {
          this.user = data;
          this.timeZone = data.timeZone;
          if (this.user.timeFormat) {
            this.timeFormat = this.user.timeFormat;
          }
        }
      });
  }


  removeTrip(memberGroup: any, dateGroup: any) {
    const dateIndex = memberGroup.dates.indexOf(dateGroup);
    if (dateIndex > -1) {
      memberGroup.dates.splice(dateIndex, 1);
    }
    if (!memberGroup.dates.length) {
      const memberIndex = this.groups.indexOf(memberGroup);
      if (memberIndex > -1) {
        this.groups.splice(memberIndex, 1);
      }
    }
  }

  getTotalTrips(memberGroup: any): number {
    return memberGroup.dates.reduce((sum: number, d: any) => sum + d.legs.length, 0);
  }

  close() {
    this.onClose.emit();
  }

  save() {
    sweetAlert(
      "Alert",
      "Are you sure you want to send bulk confirmation Call to member?",
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        const legATrips = [];
        this.groups.forEach(memberGroup => {
          memberGroup.dates.forEach((dateGroup: any) => {
            const legATrip = dateGroup.legs[0];
            legATrip.legs = dateGroup.legs.slice(1);
            legATrips.push(legATrip);
          });
        });
        this.onSave.emit(legATrips);
      }
    });
  }

  ngOnDestroy(): void {
  }
}
